module.exports = __webpack_public_path__ + "static/img/product-1.a7be2857.jpg";